<ngx-spinner
  bdColor="rgba(255,255,255,0.3)"
  [fullScreen]="true"
  type="none">
   <div class="custom-spinner">
    <div class="bus-loader">
      <div class="loader-ring"></div>
      <i class="fas fa-bus bus-icon"></i>
    </div>
  </div>
</ngx-spinner>
<router-outlet></router-outlet>
